import { useState, useEffect } from 'react';

import { useParams } from 'react-router-dom';
import { useAppContext } from '../../../contexts/app';
import { useUserContext } from '../../../contexts/user';
import useLocalStorage from '../../../hooks/useLocalStorage';
import { subscribeUserWorkspace } from '../../../services/UserWorkspaces';
import { uniqueArray } from '../../../utils/array';

export const useActivateWorkspace = () => {
  const { token } = useParams();
  const { blockScreen, handleAlert } = useAppContext();
  const { userIsLogged } = useUserContext();
  const [workspaceQueue, setWorkspaceQueue] = useLocalStorage('workspaceQueue', []);

  const [activating, setActivating] = useState(false);

  useEffect(() => {
    if (userIsLogged()) {
      blockScreen(false);
      setActivating(true);
      let activated = 0;
      const newQueue = uniqueArray([
        ...workspaceQueue,
        { workspaceId: token },
      ], 'workspaceId');

      newQueue.forEach(({ workspaceId }) => {
        if (workspaceId) {
          Promise.all([subscribeUserWorkspace(workspaceId)]).then(() => {
            activated += 1;
          }).catch((error) => {
            handleAlert(error, 'error');
          });
        }
      });

      setWorkspaceQueue([]);
      setTimeout(() => {
        setActivating(false);
        if (activated > 0) {
          handleAlert('Workspace successfully activated!', 'success');
        }
      }, 1500);
    } else {
      setWorkspaceQueue(uniqueArray([
        ...workspaceQueue,
        { workspaceId: token },
      ], 'workspaceId'));
    }
  }, []);

  return {
    activating,
  };
};
